/**
 * @author Vaibhav Raut <vaibhav@wemotiveforge.com>
 */

import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Button, Input, Modal, Select, Typography } from 'antd';
import {getAllRolesRequest} from '../../../Authorisation/AuthorisationApiActions';
import {HUMAN_READABLE_SYSTEM_ROLES, RESOURCES, SYSTEM_ROLES} from '../../../../utils/Constants';
import Notification from '../../../../utils/Notification';
import './AddUser.css';
import UtilHelper from "../../../../utils/UtilHelper";
import GenaLoader from "../../../../utils/components/GenaLoader/GenaLoader";
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'
import ButtonWithIcon from '../../../../utils/components/ButtonWithIcon/ButtonWithIcon';
import ConstantMessages from '../../../../utils/Strings';
import MobileNumber from "../../../../utils/components/MobileNumber/MobileNumber";
import {getCurrentSubscriptionPlan} from "../../../Billing/BillingApiActions";

const {Item: FormItem} = Form;
const {Option} = Select;

const notification = new Notification();

class AddUserFormComponent extends React.Component {

    /**
     * This Method executes when user selects role
     */
    onRoleChange = (value) => {
      this.setState({selectedRole: value});
    };

    constructor(props) {
      super(props);
      this.state = {
        selectedRole: undefined
      }
    }

  componentWillReceiveProps(nextProps) {
      if (this.props.visible !== nextProps.visible) {
        const {form} = this.props;
        // Reset form fields
        form.resetFields();
      }
    }

    render() {
      const {selectedRole} = this.state;
      let {visible, onCancel, onCreate, form, roles} = this.props;
      // const {getFieldDecorator, getFieldError} = form;

      // Remove ANALYST from roles as super admin can't add analyst user
      if (this.props.currentRole.isSuperAdmin) {
        roles = _.filter(roles, function (o) {
          return (o.name !== SYSTEM_ROLES.ANALYST);
        });
      } else { // Remove roles other than ANALYST as organization manager can only add ANALYST users
        roles = _.filter(roles, function (o) {
          return (o.name === SYSTEM_ROLES.ANALYST);
        });
      }

      // form fields validation rules
      const fieldsConfig = {
        username: {
          rules: [
            { required: true, whitespace: true, message: ConstantMessages.emailAddressRequired },
            { type: 'email', message: ConstantMessages.enterValidEmailAddress },
          ],
        },
        firstName: {
          rules: [
            { required: true, whitespace: true, message: ConstantMessages.firstNameRequired },
            { max: 50, message: 'Maximum 50 characters allowed' }
          ]
        },
        lastName: {
          rules: [
            { required: true, whitespace: true, message: ConstantMessages.lastNameRequired },
            { max: 50, message: 'Maximum 50 characters allowed' }
          ]
        },
        location: {
          rules: [
            { required: true, whitespace: true, message: ConstantMessages.locationRequired },
            { max: 255, message: 'Maximum 255 characters allowed' }
          ]
        },
        role: {
          rules: [
            { required: true, whitespace: true, message: 'Please select role' },
            // {validator: UtilHelper.validateBlankSpaces}
          ]
        }
      };

      if(this.state.selectedRole === SYSTEM_ROLES.ORG_MANAGER) {
        fieldsConfig['organization'] = {
          rules: [
            { required: true, whitespace: true, message: ConstantMessages.organizationRequired },
            { max: 255, message: 'Maximum 255 characters allowed' }
          ]
        };
      }
      return (
        (<Modal
          open={visible}
          title={
            <div className="flex-horizontal-gap-4">
              <CustomIcon name="UserAddPlus" width={40} height={40} />
              <Typography.Title level={2} style={{ margin: 0 }}>New User</Typography.Title>
            </div>
          }
          onCancel={onCancel}
          footer={null}
          width={800}
          bodyStyle={{
            maxHeight: '70vh',
            overflowY: 'auto'
          }}
          >
          <Form form={this.props.form} layout="vertical" style={{ width: '100%', background: 'transparent' }} onFinish={this.props.onCreate}>

            <FormItem
              name="firstName"
              label="First Name"
              rules={fieldsConfig.firstName.rules}
              >
                <Input placeholder="Enter first name"/>
            </FormItem>

            <FormItem
              name="lastName"
              label="Last Name"
              rules={fieldsConfig.lastName.rules}
              >
                <Input placeholder="Enter Last name"/>
            </FormItem>

            <FormItem
              name="username"
              label="Email Address"
              rules={fieldsConfig.username.rules}
              >
                <Input type='email' placeholder="Enter email address"/>
            </FormItem>

            <FormItem
              name="location"
              label="Location"
              rules={fieldsConfig.location.rules}
              >
                <Input placeholder="Enter location"/>
            </FormItem>

            <MobileNumber name="phone" label="Mobile Number" required />

            {/* Below field is only visible if selected role is ORG_MANAGER */}

            <FormItem
              name="role"
              label="Access Level"
              rules={fieldsConfig.role.rules}
              >
              {/* {getFieldDecorator('role', fieldsConfig.role)( */}
                <Select placeholder="Select a role" onChange={this.onRoleChange}>
                  {
                    roles && roles.map((role) => {
                      return <Option key={role.id} value={role.name}>{HUMAN_READABLE_SYSTEM_ROLES[role.name]}</Option>
                    })
                  }
                </Select>
              {/* )} */}
            </FormItem>

            {
              (selectedRole === SYSTEM_ROLES.ORG_MANAGER) &&
                <FormItem
                  // validateStatus={getFieldError('organization') ? 'error' : ''}
                  // help={getFieldError('organization') || ''}
                  name="organization"
                  label="Organization"
                  rules={fieldsConfig.organization.rules}
                  >
                  {/* {getFieldDecorator('organization', fieldsConfig.organization)( */}
                    <Input placeholder="Enter organization"/>
                  {/* )} */}
              </FormItem>
            }
            <FormItem>
              <Button className="margin-top-2" block type='primary' htmlType='submit'>Add User<CustomIcon name='UserAddPlus' /></Button>
            </FormItem>
          </Form>
        </Modal>)
      );
    }
  }
// );

const AddUserForm = (props) => {
  const [form] = Form.useForm();
  return <AddUserFormComponent form={form} {...props} />;
};

class AddUser extends React.Component {

  updateMobileNumber = (phone, validPhoneNumber) => {
    this.setState({phone, validPhoneNumber});
  };

  showModal = () => {
    this.setState({visible: true, phone: ''});
  };

  handleCancel = () => {
    this.setState({visible: false});
  };

  /**
   * Method to add new experiment
   */
  handleAddUser = (formData) => {
    // const {form} = this.formRef.props;

    this.setState({formSubmit: true}, () => {

      // form.validateFields((err, formData) => {

        // if (this.state.validPhoneNumber) {

          this.setState({showLoader: true}, () => {
            if (formData.phone.charAt(0) !== '+') {
              formData.phone = `+${formData.phone}`
            }

            this.props.handleAddUser(formData).then(response => {
              notification.show('info', 'User Added', 'User has been added to the system.');
              this.setState({showLoader: false});
              this.handleCancel();
            }, err => {
              this.setState({showLoader: false});
            });

          });

        // }

      // });
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      showLoader: false,
      formSubmit: false,
      phone: '',
      validPhoneNumber: false,
      singleUserPlan: false
    }

  };

  componentDidMount() {
    this.props.getAllRoles().then(() => {
      if(this.props.currentRole.isOrgManager) {
        this.props.getCurrentSubscriptionPlan().then(res => {
          this.setState({singleUserPlan: !!(res.noOfUsers && res.noOfUsers === 1) }, () => {
          });
        });
      }
    }, (error) => {
    });
  }

  render() {
    const {roles, loggedInUser, userResources} = this.props;

    const resource = userResources?.find(resource => resource.name === RESOURCES.USER);

    return (
      <div>
        {
          resource && resource.CREATE !== null && !this.state.singleUserPlan
            ? (<Button type='primary' onClick={this.showModal}>New User<CustomIcon name='UserAddPlus' /></Button>)
            : (<></>)
        }

        <AddUserForm
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onCreate={this.handleAddUser}
          roles={roles}
          loggedInUser={loggedInUser}
          currentRole={this.props.currentRole}
          formSubmit={this.state.formSubmit}
          updateMobileNumber={this.updateMobileNumber}
          phone={this.state.phone}
          validPhoneNumber={this.state.validPhoneNumber}
        />

        <GenaLoader showLoader={this.state.showLoader}/>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    roles: state.authorisation.roles,
    loggedInUser: state.auth.loggedInUser,
    userResources: state.authorisation.userResources,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllRoles: () => {
      return dispatch(getAllRolesRequest()).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
    getCurrentSubscriptionPlan: () => {
      return dispatch(getCurrentSubscriptionPlan()).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
  }
};

AddUser = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUser);

export default AddUser;
